import React from 'react';
import InForItem from './InForItem';
import Const from './Const';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withComponentId } from './../../common/ComponentIdContext';
import { REDUCER_NAME } from './reducer';
import { withSize } from 'react-sizeme';
import { TickerChartWrap } from './ticker-chart';

class Info extends React.PureComponent {
  state = {
    renderKey: 0,
  };

  componentWillReceiveProps(nextProps, nextContext) {
    const { data } = this.props;
    if (!data.length && nextProps.data.length) {
      this.remountChart();
    }
  }

  remountChart = () => {
    this.setState({
      renderKey: this.state.renderKey + 1,
    });
  };

  render() {
    const { renderKey } = this.state;
    const { data = [], currentSearch = {}, latestPrice = {} } = this.props;

    const priceData = {
      MatchPrice: latestPrice.matchPrice,
      PriceChange: latestPrice.priceChange,
      PercentPriceChange: latestPrice.percentPriceChange,
      ReferencePrice: latestPrice.referencePrice,
    };

    return (
      <div className="snapShot-table d-flex flex-wrap">
        <div style={{ minHeight: 230 }} className="snapShotTable-Chart d-flex">
          <TickerChartWrap key={`${currentSearch.code}_${renderKey}`} />
        </div>
        <div
          style={{ minHeight: 230 }}
          className="snapShotTable-Infor flex-fill"
        >
          <InForItem
            data={data}
            priceData={priceData}
            listItem={
              currentSearch.isBanking
                ? Const.listItemBank.listItemInforLeft
                : Const.listItemNonBank.listItemInforLeft
            }
          />
          <InForItem
            data={data}
            priceData={priceData}
            listItem={
              currentSearch.isBanking
                ? Const.listItemBank.listItemInforRight
                : Const.listItemNonBank.listItemInforRight
            }
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, { componentId }) => {
  return {
    data: state[REDUCER_NAME].listMultiComponent[componentId].data,
    currentSearch:
      state[REDUCER_NAME].listMultiComponent[componentId].currentSearch,
    latestPrice:
      state[REDUCER_NAME].listMultiComponent[componentId].latestPrice,
  };
};

export default compose(
  withComponentId,
  connect(mapStateToProps),
  withSize(),
)(Info);
